/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListAiCredentialsQueryResponse, ListAiCredentialsPathParams, ListAiCredentials400, ListAiCredentials401, ListAiCredentials403, ListAiCredentials404, ListAiCredentials409, ListAiCredentials500 } from "../../types/platformBillingController/ListAiCredentials.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListAiCredentialsUrl(organizationId: ListAiCredentialsPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/platform-billing/credentials` as const }
  return res
}

/**
 * @summary List masked BYOK provider credentials
 * {@link /api/organizations/:organizationId/platform-billing/credentials}
 */
export async function listAiCredentials(organizationId: ListAiCredentialsPathParams["organizationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListAiCredentialsQueryResponse, ResponseErrorConfig<ListAiCredentials400 | ListAiCredentials401 | ListAiCredentials403 | ListAiCredentials404 | ListAiCredentials409 | ListAiCredentials500>, unknown>({ method : "GET", url : getListAiCredentialsUrl(organizationId).url.toString(), ... requestConfig })
  return res.data
}